import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function CreateCourse(coursedata) {
  try {
    const response = await axiosInstance.post('course/createCourse', coursedata);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
